import { Api } from "../api";
import { AxiosResponse } from "axios";

/**
 * @typedef {{
 *  description: string,
 *  groupName: string,
 *  id: number,
 *  indicatorType: string,
 *  indicatorUnitTypeId: number,
 *  indicatorValues: Array,
 *  isBeforeAfter: boolean,
 *  tooltipText: string }} Indicators
 */

/**
 * @typedef {{
 *  categoryId: number,
 *  categoryNameText: string,
 *  indicators: Indicators[] }} Outputs
 */

/**
 * @typedef {{
 *  categoryId: number,
 *  categoryNameText: string,
 *  indicators: Indicators[] }} Outcomes
 */

/**
 * @typedef {{
 *  outputs: Outputs[],
 *  outcomes: Outcomes[] }} ProjectResultIndicators
 */

const api = new Api("api/Projects");

/**
 * @param projectId
 * @returns {Promise<AxiosResponse<ProjectResultIndicators[]>>}
 */
export const getProjectResultIndicators = (projectId) =>
  api.get(`/${projectId}/results/indicators`);

const normalizeProjectResultsPayload = (payload) => ({
  ...payload,

  housing: payload.housing ?? null,

  housingUnits:
    payload.housingUnits === "" || payload.housingUnits == null
      ? null
      : payload.housingUnits,

  housingAffordableUnits:
    payload.housingAffordableUnits === "" ||
    payload.housingAffordableUnits == null
      ? null
      : payload.housingAffordableUnits,

  housingLinks: payload.housingLinks?.trim() || null,
  housingMethodology: payload.housingMethodology?.trim() || null,
  housingOtherInformation: payload.housingOtherInformation?.trim() || null,
});

export const saveBrandNewProjectResults = (projectId, payload) =>
  api.post(`/${projectId}/results`, normalizeProjectResultsPayload(payload));

export const updateProjectResults = (projectId, payload) =>
  api.put(`/${projectId}/results`, normalizeProjectResultsPayload(payload));
